// Photography equipment, services and preset combos
// Sourced from SS Digital Photography Chennai pricing

export const PHOTOGRAPHY_ITEMS = [
  // Equipment / Instruments
  { name: 'HD Video Camera', category: 'Instruments', defaultQty: 1, defaultPrice: 6000 },
  { name: 'Candid Video Camera', category: 'Instruments', defaultQty: 1, defaultPrice: 8000 },
  { name: 'Candid Camera', category: 'Instruments', defaultQty: 1, defaultPrice: 5000 },
  { name: 'Traditional Camera', category: 'Instruments', defaultQty: 1, defaultPrice: 3000 },
  { name: 'DSLR Camera', category: 'Instruments', defaultQty: 1, defaultPrice: 4000 },
  { name: 'Drone / Helicam', category: 'Instruments', defaultQty: 1, defaultPrice: 15000 },
  { name: 'Gimbal Stabilizer', category: 'Instruments', defaultQty: 1, defaultPrice: 3000 },
  { name: 'Crane / Jib', category: 'Instruments', defaultQty: 1, defaultPrice: 7000 },
  { name: 'Studio Flash Light', category: 'Instruments', defaultQty: 1, defaultPrice: 2000 },
  { name: 'LED Panel Light', category: 'Instruments', defaultQty: 1, defaultPrice: 1500 },
  { name: 'Ring Light', category: 'Instruments', defaultQty: 1, defaultPrice: 1000 },
  { name: 'Softbox Kit', category: 'Instruments', defaultQty: 1, defaultPrice: 2500 },
  { name: 'Tripod', category: 'Instruments', defaultQty: 1, defaultPrice: 800 },
  { name: 'Photo Booth Setup', category: 'Instruments', defaultQty: 1, defaultPrice: 5000 },

  // Photography Services
  { name: 'Candid Photography', category: 'Services', defaultQty: 1, defaultPrice: 15000 },
  { name: 'Traditional Photography', category: 'Services', defaultQty: 1, defaultPrice: 8000 },
  { name: 'Pre-Wedding Shoot', category: 'Services', defaultQty: 1, defaultPrice: 12000 },
  { name: 'Outdoor Photoshoot', category: 'Services', defaultQty: 1, defaultPrice: 10000 },
  { name: 'Mehandi Photography', category: 'Services', defaultQty: 1, defaultPrice: 6000 },
  { name: 'Engagement Photography', category: 'Services', defaultQty: 1, defaultPrice: 8000 },
  { name: 'Birthday Photography', category: 'Services', defaultQty: 1, defaultPrice: 6000 },
  { name: 'HD Videography', category: 'Services', defaultQty: 1, defaultPrice: 12000 },
  { name: 'Candid Videography', category: 'Services', defaultQty: 1, defaultPrice: 18000 },
  { name: 'Cinematic Videography', category: 'Services', defaultQty: 1, defaultPrice: 25000 },
  { name: 'Drone Videography', category: 'Services', defaultQty: 1, defaultPrice: 15000 },
  { name: 'Live Streaming', category: 'Services', defaultQty: 1, defaultPrice: 8000 },
  { name: 'Highlight Reel (3-5 min)', category: 'Services', defaultQty: 1, defaultPrice: 10000 },

  // Deliverables
  { name: 'Album - 60 Pages', category: 'Deliverables', defaultQty: 1, defaultPrice: 5000 },
  { name: 'Album - 80 Pages', category: 'Deliverables', defaultQty: 1, defaultPrice: 7000 },
  { name: 'Album - 90 Pages', category: 'Deliverables', defaultQty: 1, defaultPrice: 9000 },
  { name: 'Lamination 18x12', category: 'Deliverables', defaultQty: 1, defaultPrice: 1500 },
  { name: 'Photo Frame 16x24', category: 'Deliverables', defaultQty: 1, defaultPrice: 2000 },
  { name: '32GB Pendrive with Files', category: 'Deliverables', defaultQty: 1, defaultPrice: 1000 },
  { name: '64GB Pendrive with Files', category: 'Deliverables', defaultQty: 1, defaultPrice: 1500 },
  { name: '1TB Hard Disk with Files', category: 'Deliverables', defaultQty: 1, defaultPrice: 4000 },
  { name: 'Photo Editing & Retouching', category: 'Deliverables', defaultQty: 1, defaultPrice: 3000 },
  { name: 'Video Colour Grading', category: 'Deliverables', defaultQty: 1, defaultPrice: 5000 },
  { name: 'Full Event Video Edit', category: 'Deliverables', defaultQty: 1, defaultPrice: 8000 },
];

// 4 preset package tiers
export const PHOTOGRAPHY_PRESET_PACKAGES = [
  {
    tier: 'budget',
    name: 'Budget Friendly',
    price: 42000,
    description: 'Engagement / Birthday / Single Event',
    // items that come pre-selected in this tier (by name)
    defaultItems: [
      { name: 'HD Video Camera', qty: 1 },
      { name: 'Candid Camera', qty: 1 },
      { name: 'Traditional Camera', qty: 1 },
      { name: 'Candid Photography', qty: 1 },
      { name: 'Traditional Photography', qty: 1 },
      { name: 'HD Videography', qty: 1 },
      { name: 'Album - 60 Pages', qty: 1 },
      { name: 'Lamination 18x12', qty: 1 },
      { name: '32GB Pendrive with Files', qty: 1 },
      { name: 'Full Event Video Edit', qty: 1 },
    ],
  },
  {
    tier: 'luxury',
    name: 'Luxury',
    price: 125000,
    description: 'Reception & Wedding',
    defaultItems: [
      { name: 'HD Video Camera', qty: 2 },
      { name: 'Candid Camera', qty: 1 },
      { name: 'Traditional Camera', qty: 1 },
      { name: 'Candid Photography', qty: 1 },
      { name: 'Traditional Photography', qty: 1 },
      { name: 'HD Videography', qty: 1 },
      { name: 'Candid Videography', qty: 1 },
      { name: 'Outdoor Photoshoot', qty: 1 },
      { name: 'Album - 80 Pages', qty: 2 },
      { name: 'Lamination 18x12', qty: 2 },
      { name: '64GB Pendrive with Files', qty: 1 },
      { name: 'Full Event Video Edit', qty: 1 },
    ],
  },
  {
    tier: 'premium',
    name: 'Premium',
    price: 275000,
    description: 'Full Wedding + Drone Coverage',
    defaultItems: [
      { name: 'HD Video Camera', qty: 2 },
      { name: 'Candid Video Camera', qty: 1 },
      { name: 'Candid Camera', qty: 2 },
      { name: 'Traditional Camera', qty: 1 },
      { name: 'Drone / Helicam', qty: 1 },
      { name: 'Candid Photography', qty: 1 },
      { name: 'Traditional Photography', qty: 1 },
      { name: 'HD Videography', qty: 1 },
      { name: 'Candid Videography', qty: 1 },
      { name: 'Drone Videography', qty: 1 },
      { name: 'Cinematic Videography', qty: 1 },
      { name: 'Outdoor Photoshoot', qty: 1 },
      { name: 'Album - 90 Pages', qty: 2 },
      { name: 'Lamination 18x12', qty: 4 },
      { name: '1TB Hard Disk with Files', qty: 1 },
      { name: 'Photo Editing & Retouching', qty: 1 },
      { name: 'Video Colour Grading', qty: 1 },
      { name: 'Highlight Reel (3-5 min)', qty: 1 },
      { name: 'Full Event Video Edit', qty: 1 },
    ],
  },
  {
    tier: 'ultra_luxury',
    name: 'Ultra Luxury',
    price: 500000,
    description: 'Complete Grand Wedding Experience',
    defaultItems: [
      { name: 'HD Video Camera', qty: 3 },
      { name: 'Candid Video Camera', qty: 2 },
      { name: 'Candid Camera', qty: 3 },
      { name: 'Traditional Camera', qty: 1 },
      { name: 'DSLR Camera', qty: 1 },
      { name: 'Drone / Helicam', qty: 2 },
      { name: 'Gimbal Stabilizer', qty: 1 },
      { name: 'Crane / Jib', qty: 1 },
      { name: 'Studio Flash Light', qty: 2 },
      { name: 'LED Panel Light', qty: 2 },
      { name: 'Photo Booth Setup', qty: 1 },
      { name: 'Candid Photography', qty: 1 },
      { name: 'Traditional Photography', qty: 1 },
      { name: 'Pre-Wedding Shoot', qty: 1 },
      { name: 'Outdoor Photoshoot', qty: 1 },
      { name: 'HD Videography', qty: 1 },
      { name: 'Candid Videography', qty: 1 },
      { name: 'Cinematic Videography', qty: 1 },
      { name: 'Drone Videography', qty: 1 },
      { name: 'Live Streaming', qty: 1 },
      { name: 'Highlight Reel (3-5 min)', qty: 1 },
      { name: 'Album - 90 Pages', qty: 3 },
      { name: 'Lamination 18x12', qty: 6 },
      { name: 'Photo Frame 16x24', qty: 2 },
      { name: '1TB Hard Disk with Files', qty: 2 },
      { name: 'Photo Editing & Retouching', qty: 1 },
      { name: 'Video Colour Grading', qty: 1 },
      { name: 'Full Event Video Edit', qty: 1 },
    ],
  },
];

export const getAllItemCategories = () => {
  return [...new Set(PHOTOGRAPHY_ITEMS.map(item => item.category))];
};
